import intl from "./intl";
export default intl;